{
    "PartitionModal_AddTitle": "Aggiungi partizione",
    "PartitionModal_ChangeTitle": "Cambia partizione",
    "PartitionModal_ViewTitle": "Partizione di visualizzazione",
    "PartitionModal_PromptMessage": "Sono presenti modifiche alla partizione non salvate. Uscire senza salvare?",
    "PartitionModal_PromptConfirm": "Uscita",
    "PartitionModal_PromptCancel": "Cancellare",
    "PartitionModal_Tab_Details": "Dettagli",
    "PartitionModal_Tab_SiteSettings": "Impostazioni del sito",
    "PartitionModal_Tab_Synchronisation": "Sincronizzazione",
    "PartitionModal_Tab_Advanced": "Avanzato",
    "PartitionModal_Tab_CommunicationStatus": "Stato di sincronizzazione",
    "PartitionModal_Loading": "Caricamento...",
    "PartitionModal_Button_Close": "Vicino",
    "PartitionModal_Button_Cancel": "Cancellare",
    "PartitionModal_Button_Save": "Salva",
    "PartitionModal_RequestFailed": "Richiesta non riuscita",
    "PartitionModal_General_Description": "Descrizione",
    "PartitionModal_General_DescriptionRequired": "È necessaria una descrizione",
    "PartitionModal_General_IDInTelSys": "No nel server di telefonia (Automatico)",
    "PartitionModal_General_IDInTelSysRequired": "No. nel server di telefonia è richiesto",
    "PartitionModal_General_Tags": "Etichetta",
    "PartitionModal_Details_Identifier": "Identificativo",
    "PartitionModal_Details_IdentifierPlaceholder": "[Assegnazione automatica]",
    "PartitionModal_Details_BillingIdOrTag": "ID\/Tag di fatturazione",
    "PartitionModal_Details_BilledMonthly": "Fatturazione mensile",
    "PartitionModal_Details_LicensedFor": "Autorizzato per",
    "PartitionModal_Details_DeleteAcdAgentsOnDowngrade": "Elimina automaticamente le voci dell'agente ACD",
    "PartitionModal_LicensedFor_None": "Nessuno",
    "PartitionModal_LicensedFor_AkixiLite": "Akixi Lite",
    "PartitionModal_LicensedFor_AkixiBLF": "Akixi BLF",
    "PartitionModal_LicensedFor_AkixiONE": "Akixi ONE",
    "PartitionModal_LicensedFor_Akixi1000": "Akixi 1000",
    "PartitionModal_LicensedFor_Enterprise": "Imprese",
    "PartitionModal_LicensedFor_Akixi2000": "Akixi 2000",
    "PartitionModal_LicensedFor_Essentials": "Elementi essenziali",
    "PartitionModal_LicensedFor_Professional": "Professionale",
    "PartitionModal_LicensedFor_CallCentreAgent": "Operatore del call center",
    "PartitionModal_LicensedFor_CallCentreSupervisor": "Supervisore del call center",
    "PartitionModal_Details_CommonDevices": "Contiene dispositivi comuni",
    "PartitionModal_Details_CommonDevicesPanasonic": "Contiene dispositivi comuni (solo dispositivi DP comuni)",
    "PartitionModal_Details_CommunicationEnabled": "Comunicazione abilitata",
    "PartitionModal_Site_Timezone": "Fuso orario",
    "PartitionModal_Site_StartOfDay": "Inizio della giornata (ora locale)",
    "PartitionModal_Site_RecordingPlayback": "Riproduzione della registrazione",
    "PartitionModal_Site_RecordingPlayback_None": "Nessuno",
    "PartitionModal_Site_E164Enabled": "E.164 abilitato",
    "PartitionModal_Site_InternalDigitLength": "lunghezza cifra interna",
    "PartitionModal_Site_CountryCodeLocation": "Codice Paese Località",
    "PartitionModal_Sync_NoSettings": "Per questo tipo di server telefonico non si applicano impostazioni di sincronizzazione.",
    "PartitionModal_Sync_CommonDevicesNoSettings": "Nessuna impostazione di sincronizzazione si applica a una partizione di dispositivi comuni.",
    "PartitionModal_Sync_NameOnTelephonyServer": "Nome sul server di telefonia",
    "PartitionModal_Sync_IDOnTelephonyServerOid": "ID sul server di telefonia (OID)",
    "PartitionModal_Sync_SynchronisationTypeSoftOnly": "Tipo di sincronizzazione (solo software)",
    "PartitionModal_Sync_EnterpriseOrProviderID": "ID aziendale o del fornitore",
    "PartitionModal_Sync_SynchronisationType": "Tipo di sincronizzazione",
    "PartitionModal_Sync_WebexEnvironmentType": "Tipo di ambiente Webex",
    "PartitionModal_Sync_TeamsEnvironmentType": "Tipo di ambiente Team",
    "PartitionModal_Sync_EnterpriseID": "ID aziendale",
    "PartitionModal_Sync_GroupID": "ID di gruppo",
    "PartitionModal_Sync_UserInLocation": "Utente nella posizione",
    "PartitionModal_Sync_IDOnTelephonyServer": "ID sul server di telefonia",
    "PartitionModal_Sync_TypeOnTelSys": "Digita su Telsys",
    "PartitionModal_Sync_WebexTypeEnvironment": "Ambiente di tipo Webex",
    "PartitionModal_Sync_ComponentType_Unknown": "[Tipo sconosciuto o non specificato]",
    "PartitionModal_Sync_ComponentType_BroadWorks_Enterprise": "Imprese",
    "PartitionModal_Sync_ComponentType_BroadWorks_EnterpriseGroup": "Gruppo aziendale",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProvider": "Fornitore di servizi",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProviderGroup": "Gruppo di fornitori di servizi",
    "PartitionModal_Sync_ComponentType_Webex_Organisation": "Organizzazione",
    "PartitionModal_Sync_ComponentType_Webex_Location": "Posizione",
    "PartitionModal_Sync_Environment_None": "Nessuno",
    "PartitionModal_Sync_Environment_Tenant": "Inquilino",
    "PartitionModal_Sync_Environment_AuthoriserSelect": "Autorizza la selezione",
    "PartitionModal_Sync_Environment_SecurityGroups": "gruppi di sicurezza",
    "PartitionModal_Sync_SynchronisationType_Soft": "Morbido",
    "PartitionModal_Sync_SynchronisationType_OneTimeFull": "Una tantum completa",
    "PartitionModal_Sync_SynchronisationType_Full": "Pieno",
    "PartitionModal_Sync_SynchronisationType_ServicePack": "Pacchetto di servizio",
    "PartitionModal_Sync_SecurityGroups": "Gruppi di sicurezza",
    "PartitionModal_Sync_SyncOptions": "Opzioni di sincronizzazione",
    "PartitionModal_Sync_SyncOptions_None": "Nessuno",
    "PartitionModal_Sync_SyncOptions_Endpoints": "Punti terminali",
    "PartitionModal_Sync_SyncOptions_Trunking": "Canalizzazione",
    "PartitionModal_Sync_SyncOptions_Agents": "Agenti + estensioni associate",
    "PartitionModal_Sync_SyncOptions_Supervisors": "Supervisori",
    "PartitionModal_Sync_MaintainParity": "Mantenere la parità",
    "PartitionModal_Sync_ForceMonitored": "Monitoraggio forzato",
    "PartitionModal_Sync_SupervisorPermissions": "Abilita per impostazione predefinita le autorizzazioni di supervisore del server di telefonia.",
    "PartitionModal_Sync_SyncNow": "Sincronizza ora",
    "PartitionModal_Sync_PhotoSyncNow": "Sincronizza le foto ora",
    "PartitionModal_Advanced_CtiLoggingEnabled": "Registrazione CTI",
    "PartitionModal_Advanced_Trunking": "Canalizzazione",
    "PartitionModal_Advanced_TrunkingBurst": "Tronco (Esplosione)",
    "PartitionModal_Advanced_TrunkingCapacity": "Capacità di trasporto",
    "PartitionModal_Advanced_TrunkingCapacityBurst": "Capacità di carico (scoppio)",
    "PartitionModal_Advanced_TrunkCapacity": "Capacità del bagagliaio",
    "PartitionModal_Advanced_TrunkCapacityBurst": "Capacità del bagagliaio (di scoppio)",
    "PartitionModal_CommStatus_SyncStatusTitle": "Stato di sincronizzazione",
    "PartitionModal_CommStatus_SyncLastStarted": "Ultimo avvio alle:",
    "PartitionModal_CommStatus_SyncLastStarted_Placeholder": "—",
    "PartitionModal_CommStatus_SyncLastError": "Stato\/errore di sincronizzazione",
    "PartitionModal_CommStatus_SyncLastError_Placeholder": "Al momento non sono disponibili informazioni sullo stato della sincronizzazione.",
    "NAME": "PartitionModal"
}